import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, makeStyles, TableFooter, TablePagination, TableRow, useTheme } from '@material-ui/core';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		marginLeft: theme.spacing(2.5)
	}
}));

const TablePaginationActions = (props) => {
	const { root } = useStyles();
	const theme = useTheme();
	const { count, page, rowsPerPage, filters, onChangePage: updatePagination } = props;
    const dispatch = useDispatch();

	const handleFirstPageButtonClick = () => {
		dispatch(updatePagination({ page: 0, rowsPerPage, filters }));
	};

	const handleBackButtonClick = () => {
		dispatch(updatePagination({ page: page - 1, rowsPerPage, filters }));
	};

	const handleNextButtonClick = () => {
		dispatch(updatePagination({ page: page + 1, rowsPerPage, filters }));
	};

	const handleLastPageButtonClick = () => {
		dispatch(updatePagination({ page: Math.max(0, Math.ceil(count / rowsPerPage) - 1), rowsPerPage, filters }));
	};

	return (
		<div className={root}>
			<IconButton
				onClick={handleFirstPageButtonClick}
				disabled={page === 0}
				aria-label='first page'
			>
				{theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
			</IconButton>
			<IconButton
				onClick={handleBackButtonClick}
				disabled={page === 0}
				aria-label='previous page'
			>
				{theme.direction === 'rtl' ? (
					<KeyboardArrowRight />
				) : (
					<KeyboardArrowLeft />
				)}
			</IconButton>
			<IconButton
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label='next page'
			>
				{theme.direction === 'rtl' ? (
					<KeyboardArrowLeft />
				) : (
					<KeyboardArrowRight />
				)}
			</IconButton>
			<IconButton
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label='last page'
			>
				{theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
			</IconButton>
		</div>
	);
};

TablePaginationActions.propTypes = {
	count: PropTypes.number.isRequired,
	onChangePage: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
    filters: PropTypes.object
};

const TablePaginationComponent = ({ count, rowsPerPage, page, filters, updatePagination }) => {
    const dispatch = useDispatch();

    return (
        <TableFooter>
            <TableRow>
                <TablePagination
                    rowsPerPageOptions={[ 10, 25, 100 ]}
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                        inputProps: { 'aria-label': 'broj redova po stranici' }
                    }}
                    labelRowsPerPage="Broj redova po stranici"
                    labelDisplayedRows={({ from, to, count }) => '' + from + '-' + to + ' od ' + count}
                    onChangePage={updatePagination}
                    onChangeRowsPerPage={(e) => dispatch(updatePagination({ rowsPerPage: e.target.value, filters }))}
                    ActionsComponent={(props) => <TablePaginationActions {...props} filters={filters} />}
                />
            </TableRow>
        </TableFooter>
    )
}

TablePaginationComponent.propTypes = {
	count: PropTypes.number.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
    filters: PropTypes.object,
	updatePagination: PropTypes.func.isRequired
};

TablePaginationComponent.defaultProps = {
    count: 0,
    rowsPerPage: 10,
    page: 0,
    filters: {}
}

export default TablePaginationComponent;
